import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
import AntdModal from './Modal';
import MiddleModal from './MiddleModal';
import LargeModal from './LargeModal';
import ConfirmModal from './ConfirmModal';
import confirm, { withWarn, withInfo, withSuccess, withError, withConfirm, modalGlobalConfig } from 'antd/lib/modal/confirm';
import useModal from 'antd/lib/modal/useModal';
import destroyFns from 'antd/lib/modal/destroyFns';
var Modal = AntdModal;
Modal.Middle = MiddleModal;
Modal.Large = LargeModal;
Modal.Confirm = ConfirmModal;
Modal.useModal = useModal;
Modal.info = props => {
  return confirm(withInfo(_objectSpread(_objectSpread({}, props), {}, {
    cancelButtonProps: {
      className: 'sk-button'
    },
    okButtonProps: {
      className: 'sk-button'
    }
  })));
};
Modal.success = props => {
  return confirm(withSuccess(_objectSpread(_objectSpread({}, props), {}, {
    cancelButtonProps: {
      className: 'sk-button'
    },
    okButtonProps: {
      className: 'sk-button'
    }
  })));
};
Modal.error = props => {
  return confirm(withError(_objectSpread(_objectSpread({}, props), {}, {
    cancelButtonProps: {
      className: 'sk-button'
    },
    okButtonProps: {
      className: 'sk-button'
    }
  })));
};
function modalWarn(props) {
  return confirm(withWarn(_objectSpread(_objectSpread({}, props), {}, {
    cancelButtonProps: {
      className: 'sk-button'
    },
    okButtonProps: {
      className: 'sk-button'
    }
  })));
}
Modal.warning = modalWarn;
Modal.warn = modalWarn;
Modal.confirm = props => {
  return confirm(withConfirm(_objectSpread(_objectSpread({}, props), {}, {
    cancelButtonProps: {
      className: 'sk-button'
    },
    okButtonProps: {
      className: 'sk-button'
    }
  })));
};
Modal.destroyAll = () => {
  while (destroyFns.length) {
    var close = destroyFns.pop();
    if (close) {
      close();
    }
  }
};
Modal.config = modalGlobalConfig;
export default Modal;